import { render, staticRenderFns } from "./TAddAdministratorSystem.vue?vue&type=template&id=091896c4&"
import script from "./TAddAdministratorSystem.vue?vue&type=script&lang=js&"
export * from "./TAddAdministratorSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports